export default __webpack_public_path__ + "static/media/spaceStation3.ede9bc2f.webp";